new Vue({
    el: '#vue_banner_v2',
    data: {
        bannersTopo: window.vueData.bannersTopo,
    },
    methods: {
        // MUDANCA 1 (17/09/2026): banner SEM link nao leva a lugar nenhum. Antes, quando o link era
        // nulo (banner cadastrado sem link), a comparacao "!== ''" passava e o navegador ia para ".../null".
        bannerClick (item) {
            var link = item && item.link ? String(item.link).trim() : '';

            if (link !== '') {
                document.location.href = link;
            }
        }
    }
});
